import { ALIGNMENT } from 'prose-core'
import { useAlignButtonToggle } from 'common/Prose/Toolbar/hooks/useAlignButtonToggle'
import { SingleMenuDropdownItem } from '../SingleMenuDropdown/SingleMenuDropdownItem'
import { observer } from 'mobx-react-lite'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const AlignCenterButton = observer(() => {
  const { active, handleClick } = useAlignButtonToggle(ALIGNMENT.Center)

  return (
    <SingleMenuDropdownItem
      icon={<ToolbarIcon name={IconName.AlignCenter} />}
      label="Center"
      ariaLabel="Align center"
      active={active}
      handleClick={handleClick}
    />
  )
})
